'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoDocument = function IoDocument(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm30.9 13.2c0.1 0.2 0.1 0.4 0.1 0.7v19.1c0 1-0.7 2-1.6 2h-19c-1 0-1.9-1-1.9-2v-26.2c0-1 0.9-1.8 1.9-1.8h12.5c0.2 0 0.4 0 0.7 0.2 0.1 0 0.4 0.1 0.5 0.3l6.5 7.2c0.2 0.1 0.2 0.3 0.3 0.5z m-7.3-4.5v4.9h4.5z m-12.6 23.8h17.5v-16.4h-5.2c-1.2 0-2.2-1-2.2-2.2v-6.4h-10.1v25z' })
        )
    );
};

exports.default = IoDocument;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/document.js
// module id = 2244
// module chunks = 0